/** Keep the same platform identity on the emergency RU domain. Does not rewrite URLs. */
export function getIntegrationHost(host: string = window.location.hostname): string {
    return host.replace(/(^|\.)mland\.mobi$/, '$1zazer.mobi');
}

export function isRustoreHost(host: string = window.location.hostname): boolean {
    return host === 'apk.lglass.mobi' || host === 'apk.mland.mobi';
}
